import { useState, useEffect } from 'react';
import { client } from '../../sdkAdapter';
import Swal from 'sweetalert2';
import {
    Table,
    TableBody,
    TableCell,
    TableHeader,
    TableRow,
} from "../ui/table";
// import Button from '../ui/button/Button';
import ShippingServiceModal from '../modals/ShippingServiceModal';

export default function ShippingTable() {
    const [services, setServices] = useState<any[]>([]);

    // Modals state
    const [serviceModalOpen, setServiceModalOpen] = useState(false);
    const [selectedService, setSelectedService] = useState<any>(null);

    const fetchData = async () => {
        try {
            const [servicesRes] = await Promise.all([
                client.getApiShippingShippingServices() as any
            ]);

            const servicesData = servicesRes.data?.data || [];

            setServices(Array.isArray(servicesData) ? servicesData : []);
        } catch (err) {
            console.error('Failed to fetch shipping data:', err);
        } finally {
        }
    };

    useEffect(() => {
        fetchData();
    }, []);

    const handleDeleteService = async (id: number) => {
        const result = await Swal.fire({
            title: 'Are you sure?',
            text: "You won't be able to revert this!",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes, delete it!'
        });

        if (!result.isConfirmed) return;
        try {
            await client.postApiShippingShippingServiceDelete({
                postApiShippingShippingServiceDeleteRequest: { id }
            });
            fetchData();
        } catch (err: any) {
            Swal.fire({
                title: 'Error',
                text: 'Failed to delete: ' + (err?.message || 'Unknown error'),
                icon: 'error'
            });
        }
    };

    return (
        <div className="space-y-6">
            {/* Shipping Services Section */}
            <div className="rounded-xl border border-gray-200 bg-white dark:border-gray-800 dark:bg-gray-900 overflow-hidden">

                <div className="p-4 border-b border-gray-200 dark:border-gray-800 flex justify-between items-center bg-gray-50/50 dark:bg-white/[0.02]">
                    <h3 className="text-lg font-bold text-gray-800 dark:text-white">Shipping Services</h3>
                    <div className="flex items-center gap-2">

                        <button onClick={() => { setSelectedService(null); setServiceModalOpen(true); }}
                            className="px-4 py-2 bg-brand-500 text-white rounded-lg hover:bg-brand-600 transition-colors text-sm font-medium shadow-sm shadow-brand-500/20"
                        >
                            Add Flat Rate
                        </button>
                    </div>
                </div>
                <div className="overflow-x-auto">
                    <Table>
                        <TableHeader>
                            <TableRow>
                                <TableCell isHeader className="px-5 py-3 text-start">Name</TableCell>
                                <TableCell isHeader className="px-5 py-3 text-start">Label</TableCell>
                                <TableCell isHeader className="px-5 py-3 text-start">Slug</TableCell>
                                <TableCell isHeader className="px-5 py-3 text-start">Active</TableCell>
                                <TableCell isHeader className="px-5 py-3 text-end">Actions</TableCell>
                            </TableRow>
                        </TableHeader>
                        <TableBody>
                            {services.length === 0 ? (
                                <TableRow><TableCell colSpan={5} className="px-5 py-4 text-center">No shipping services found.</TableCell></TableRow>
                            ) : (
                                services.map(item => (
                                    <TableRow key={item.id}>
                                        <TableCell className="px-5 py-4 font-medium">{item.name}</TableCell>
                                        <TableCell className="px-5 py-4">{item.label}</TableCell>
                                        <TableCell className="px-5 py-4 text-gray-500">{item.slug}</TableCell>
                                        <TableCell className="px-5 py-4">
                                            {item.active === "1" ? (
                                                <span className="text-green-600 font-medium text-xs bg-green-100 px-2 py-1 rounded">
                                                    Active
                                                </span>
                                            ) : (
                                                <span className="text-gray-500 font-medium text-xs bg-gray-100 px-2 py-1 rounded">
                                                    Inactive
                                                </span>
                                            )}
                                        </TableCell>

                                        <TableCell className="px-5 py-4 text-end">
                                            <div className="flex justify-end gap-2">
                                                <button onClick={() => { setSelectedService(item); setServiceModalOpen(true); }} className="text-blue-600 hover:underline"><svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z" />
                                                </svg>
                                                </button>
                                                <button onClick={() => handleDeleteService(item.id)} className="text-red-600 hover:underline"><svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
                                                </svg>
                                                </button>
                                            </div>
                                        </TableCell>
                                    </TableRow>
                                ))
                            )}
                        </TableBody>
                    </Table>
                </div>
            </div>



            <ShippingServiceModal
                isOpen={serviceModalOpen}
                onClose={() => setServiceModalOpen(false)}
                onSave={fetchData}
                service={selectedService}
            />


        </div>
    );
}
